
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutlvZ_4569agGXrx3tEG37dDXRVdh4Cerj8LrNZg7BHJGikMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/about.vue?macro=true";
import { default as errorlI8kWynC6LuUuOUl78IXz83t_45MVNJkERtGH3GZpBdFkMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/error.vue?macro=true";
import { default as indexkPEdxbuZ_456KNUVfrPWBCGNnnpEcG9KjGVGgAfluNo_45oMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/index.vue?macro=true";
import { default as loginzL46_2DknaAiF6JPtnMStAGw0P7H2pk_edZrUAyqos0Meta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/login.vue?macro=true";
import { default as terms_45g6CbMDAqMQGqVSQRC_QcoiGxGOodRejdig2MBtfYToMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/terms.vue?macro=true";
import { default as indexUKJTNPl2cVvgS_WMS4EjAUvszOlGQBPIZHPdgFUYVS8Meta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/index.vue?macro=true";
import { default as ordersfkHhCSfs13JCnbxdxtDTJpMQh63VUaPPqDXK0zfmeIEMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/orders.vue?macro=true";
import { default as recent_CANx0M0X_45t_0fyHBjbUfA5t_45AW0KduhHOLZ_GRWuL0Meta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/recent.vue?macro=true";
import { default as profileV_45sozTp2YBC1AiNd_2cc_VXhxm_5ROZMbchTxY77GT8Meta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/profile.vue?macro=true";
import { default as settingsTN8BoZqsghmFO_456DKF1bgvKkGbljx9yT6jBed_fT0F0Meta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/settings.vue?macro=true";
import { default as wishlistLefhtq2cz1U1ONQX4_dSWuxeobHld0jB59_45NanTCNdMMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/wishlist.vue?macro=true";
import { default as addressesd3Rtmqj_Nr_45V64ACozUQDnTCByCPCSRQfczW_q3TXi8Meta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/addresses.vue?macro=true";
import { default as notifications_0Rme0co_Qa2cRwJzkzRagewr96O_45AEBKKF_45_3Mpo0MMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/notifications.vue?macro=true";
import { default as reset_45password8Nhuj3KA_45urjHvEyBUaHv45iPwMfvjouhmVntxtxQIcMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/reset-password.vue?macro=true";
import { default as _91id_93zDWxwlxf4S4owoKnUtBSqRcFF17Szh3FGimUtg77rH8Meta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/notification/[id].vue?macro=true";
import { default as _91invoiceId_93GKbiHLvbQOE1AJoVXznUD4HxEqEcuNJwdTbfLcNkEZoMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/order/[type]/[invoiceId].vue?macro=true";
import { default as accountomlKmDdKwpdTXP6M5VM4Qd2oEouKNPYmixrMc6JghywMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account.vue?macro=true";
import { default as colofonf0SyTye_MA8Qwg_45lkyAmSAUkx3e3opCaF1HmQ_45GLaJEMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/colofon.vue?macro=true";
import { default as contact6tJa2oNZh0uu42xozzpnM5mbGmnzJvn8ZulzZ0KhWIMMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/contact.vue?macro=true";
import { default as cookiesqbwbiEc5ILF1Z63fUNgiYZ_45yyaF2aQT8FZfd0RjRPSQMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/cookies.vue?macro=true";
import { default as privacyzlhnXH5_45dzXPQ5GWN7LxRLiltZ3tHRqI927hZyGKyocMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/privacy.vue?macro=true";
import { default as reviewsOAP9Nhkp8sEW_45VF1sZGKcL5_5jyOhOI2jEHljNunyQ8Meta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/reviews.vue?macro=true";
import { default as registerX0hvzRySCu5SEcY2UpXS_45NFxGqU9TsY7VLsB_PPHht4Meta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/register.vue?macro=true";
import { default as wishlistKqDZg24K9mmlCASueU_45HQhC43zaDU75mnL_45stZHuTzcMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/wishlist.vue?macro=true";
import { default as _91_46_46_46slug_93ncmFUK4YCc8WluUqD7_VRCeHXgu3yjYL08nOuerGsOMMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/[...slug].vue?macro=true";
import { default as giftcardsnjD2wAbaKQEmxPSmj9VufxG27NGdz3JRaZsE9uyhj8YMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/giftcards.vue?macro=true";
import { default as storyblokhlrrgK47_45d_QTi_5IlQsbUtHLWpLtNL867iWsfkKTHsMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/storyblok.vue?macro=true";
import { default as thank_45you_46clientdtJ5Si7JJQDyxdqNd1tsJUpaefMNyGBuADDGbjbaG7YMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/thank-you.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/etc/buildAgent/work/74baefd00478bfe1/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as thank_45youBfAbgXxQZNHOZOGi4hBjkk4yUmYUlRv7cLjaWkBjilsMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/thank-you.vue?macro=true";
import { default as foundationkSb1L1j0pIE_Eo5N16IfviP48xZxD5yDMSuQo_45tczXcMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/foundation.vue?macro=true";
import { default as newsletterG0VTqF9SQCnxwnQxrJGlNk5Vb8k0bAMxrVoNI8w_45aR0Meta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/newsletter.vue?macro=true";
import { default as promotionsdmD817B6O7HhBvcq6kEWfoGRuF_45U6neQBb0fOsvDD_45UMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/promotions.vue?macro=true";
import { default as mapFOSZmwLgAKL9Z_WC8TUuanKkhg34njeRDrQ_45sJa6E1cMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/stores/map.vue?macro=true";
import { default as styleguideTcGmbbEmSfbgRBg2Vr_MeEHUOKvtm_45UhWU_vqFve_14Meta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/styleguide.vue?macro=true";
import { default as cart_46clientZK7Nn1_toq2CiT6zmINWbyD7A19BmunoSFgaXFMoxO4Meta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/cart.client.vue?macro=true";
import { default as guts_45planetY73h89HxfOM6EqtSrCxCf_45U9xKnBTfMZu3BZ2fqW22IMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/guts-planet.vue?macro=true";
import { default as index7qRTwUKS8lcnUdrI0vW8sFnvcE0LcL8zeKvRVr7oON4Meta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/stores/index.vue?macro=true";
import { default as indexM1ql5_45U_45hRbULnFxMPaZN6_iUEbzJcKD5Vwsp1HdgAMMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/minipos/index.vue?macro=true";
import { default as indexqjNKC0YIucVdx7GxsWpMYpcNPBW5IK8NwlVCRLO5eigMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/index.vue?macro=true";
import { default as infoexPae9Zz0udmvgeok_45QTBmg4O1ugjZaldirKH8hrV9UMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/warchild/info.vue?macro=true";
import { default as _91_46_46_46slug_93j2_DViDrnEMgY_45v9zlzHRg6hjFbp6O_45_XLQ5f2Rcn0UMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/win/[...slug].vue?macro=true";
import { default as checkout_45loginHDAh8ELKMfliA7DWgiu54qrTLf76Vb56CGg3bm96TfcMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/checkout-login.vue?macro=true";
import { default as index4HN5Q9V2feOqL79jvJ9WMhtWaOrQDwZvT02QJruYpOwMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/checkout/index.vue?macro=true";
import { default as _91store_93WGirc6OsWqAXb8QL1uUNmX_juYa2_45_2nc_45KYQtA4DScMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/stores/[store].vue?macro=true";
import { default as index4lINu85WwdkJ5rE1vwxxi5VJ6pBVliGtiio2uZUaRUsMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/warchild/index.vue?macro=true";
import { default as forgot_45password0iNiajZaKHK3n3dosGtYXxHzrBvr0Ezl1swaFXm293AMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/forgot-password.vue?macro=true";
import { default as recent_45productse3_s2cPc1SkTMMVzuVi75SHlqOmMDcWxxYINIRujPzYMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/recent-products.vue?macro=true";
import { default as contacthnZXVdKuAOyrlPsgCEjqyGDcLHvX9q4MZQkh2_1j1u4Meta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/contact.vue?macro=true";
import { default as resultsy6GUcflwuQtVqg1ll04Y1CeFv9eJIUti89_45jObLcJykMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/results.vue?macro=true";
import { default as studentenrabattseVCABHtzNN0wPnu1qFK0vr2mkyFqKlTvzsoQcr__uQMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/studentenrabatt.vue?macro=true";
import { default as indexDkp5kJJfoPqHmxd47Yfa8j3xEINpG8_VrK09X0Fw5s0Meta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/vacancies/index.vue?macro=true";
import { default as pendingeHuBRtCn2rZjoLo_7LLH_45nsEOdW8AcgLal6DsYL9yTgMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/checkout/pending.vue?macro=true";
import { default as _91_46_46_46slug_932QYEwk63ck0GtdfoZDK3THChAbAE77XGlLV9PB2L5a0Meta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/signup/[...slug].vue?macro=true";
import { default as privacyBETXmK3F_K99nkI6ejj8T8bTUSQ7X8bbqJvmnhhp34IMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/vacancies/privacy.vue?macro=true";
import { default as _91token_93qhZAvqDDNdHg81HR928CP3lvOcTVZBdzA7YyYGWstr4Meta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/activation/[token].vue?macro=true";
import { default as _91id_93k8OCAjesg_45ikFVFEiebrO9pgAfT_HRbflvy4lXIFGzoMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/product/[slug]/[id].vue?macro=true";
import { default as _91token_93dGD40yDE8l2i8Xj6ZkkbZ9OvB3DrgFJmJliiZ_45lWA7AMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/reset-password/[token].vue?macro=true";
import { default as indexdrpKt16xgfABldF47ZiLVQmA9Cn1v2jbeqLXIrPaDIQMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/vacancies/[city]/index.vue?macro=true";
import { default as indexjCUPoOcGSddFSzfj1Y_B6zOTZQdJWA7_zh6VaTcNipMMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/[subject]/index.vue?macro=true";
import { default as newsletter_45language_46clientbX0PPGADoizcHoLbX6iFVbO942qQFkB6YmW64voz0qoMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/newsletter-language.client.vue?macro=true";
import { default as _91searchTerm_937HAemaTpmaDx8Xgd3x_vycC5niIzJM8XFUcjX1djCtQMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/search-detail/[searchTerm].vue?macro=true";
import { default as _91answer_93cPRSaJwvRh5v5w4Oi_lBjtPbVs3kMK4UgWbxGEW3B7QMeta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/[subject]/[answer].vue?macro=true";
import { default as _91vacancy_93VzH2w4i3YzI10dwga5zHwz8_45Vbg3XpFhgYTWavilOH8Meta } from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/vacancies/[city]/[title]/[vacancy].vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/about.vue")
  },
  {
    name: "error",
    path: "/error",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/login.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/terms.vue")
  },
  {
    name: accountomlKmDdKwpdTXP6M5VM4Qd2oEouKNPYmixrMc6JghywMeta?.name,
    path: "/account",
    meta: {"middleware":"authenticated"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account.vue"),
    children: [
  {
    name: "account",
    path: "",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/index.vue")
  },
  {
    name: "account-orders",
    path: "orders",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/orders.vue")
  },
  {
    name: "account-recent",
    path: "recent",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/recent.vue")
  },
  {
    name: "account-profile",
    path: "profile",
    meta: {"middleware":"authenticated"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/profile.vue")
  },
  {
    name: "account-settings",
    path: "settings",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/settings.vue")
  },
  {
    name: "account-wishlist",
    path: "wishlist",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/wishlist.vue")
  },
  {
    name: "account-addresses",
    path: "addresses",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/addresses.vue")
  },
  {
    name: "account-notifications",
    path: "notifications",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/notifications.vue")
  },
  {
    name: "account-reset-password",
    path: "reset-password",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/reset-password.vue")
  },
  {
    name: "account-notification-id",
    path: "notification/:id()",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/notification/[id].vue")
  },
  {
    name: "account-order-type-invoiceId",
    path: "order/:type()/:invoiceId()",
    meta: { ...(_91invoiceId_93GKbiHLvbQOE1AJoVXznUD4HxEqEcuNJwdTbfLcNkEZoMeta || {}), ...{"middleware":"authenticated"} },
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/order/[type]/[invoiceId].vue")
  }
]
  },
  {
    name: "colofon",
    path: "/colofon",
    meta: colofonf0SyTye_MA8Qwg_45lkyAmSAUkx3e3opCaF1HmQ_45GLaJEMeta || {},
    alias: ["/de/colofon"],
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/colofon.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/contact.vue")
  },
  {
    name: "cookies",
    path: "/cookies",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/cookies.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/privacy.vue")
  },
  {
    name: "reviews",
    path: "/reviews",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/reviews.vue")
  },
  {
    name: "register",
    path: "/register",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/register.vue")
  },
  {
    name: "wishlist",
    path: "/wishlist",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/wishlist.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/[...slug].vue")
  },
  {
    name: "giftcards",
    path: "/giftcards",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/giftcards.vue")
  },
  {
    name: "storyblok",
    path: "/storyblok",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/storyblok.vue")
  },
  {
    name: thank_45youBfAbgXxQZNHOZOGi4hBjkk4yUmYUlRv7cLjaWkBjilsMeta?.name,
    path: "/thank-you",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/thank-you.vue"),
    children: [
  {
    name: "thank-you",
    path: "",
    component: () => createClientPage(() => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/thank-you.client.vue"))
  }
]
  },
  {
    name: "foundation",
    path: "/foundation",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/foundation.vue")
  },
  {
    name: "newsletter",
    path: "/newsletter",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/newsletter.vue")
  },
  {
    name: "promotions",
    path: "/promotions",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/promotions.vue")
  },
  {
    name: "stores-map",
    path: "/stores/map",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/stores/map.vue")
  },
  {
    name: "styleguide",
    path: "/styleguide",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/styleguide.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => createClientPage(() => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/cart.client.vue"))
  },
  {
    name: "guts-planet",
    path: "/guts-planet",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/guts-planet.vue")
  },
  {
    name: "stores",
    path: "/stores",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/stores/index.vue")
  },
  {
    name: "minipos",
    path: "/minipos",
    meta: indexM1ql5_45U_45hRbULnFxMPaZN6_iUEbzJcKD5Vwsp1HdgAMMeta || {},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/minipos/index.vue")
  },
  {
    name: "service",
    path: "/service",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/index.vue")
  },
  {
    name: "warchild-info",
    path: "/warchild/info",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/warchild/info.vue")
  },
  {
    name: "win-slug",
    path: "/win/:slug(.*)*",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/win/[...slug].vue")
  },
  {
    name: "checkout-login",
    path: "/checkout-login",
    meta: checkout_45loginHDAh8ELKMfliA7DWgiu54qrTLf76Vb56CGg3bm96TfcMeta || {},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/checkout-login.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: index4HN5Q9V2feOqL79jvJ9WMhtWaOrQDwZvT02QJruYpOwMeta || {},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/checkout/index.vue")
  },
  {
    name: "stores-store",
    path: "/stores/:store()",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/stores/[store].vue")
  },
  {
    name: "warchild",
    path: "/warchild",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/warchild/index.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/forgot-password.vue")
  },
  {
    name: "recent-products",
    path: "/recent-products",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/recent-products.vue")
  },
  {
    name: "service-contact",
    path: "/service/contact",
    meta: contacthnZXVdKuAOyrlPsgCEjqyGDcLHvX9q4MZQkh2_1j1u4Meta || {},
    alias: ["/contact"],
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/contact.vue")
  },
  {
    name: "service-results",
    path: "/service/results",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/results.vue")
  },
  {
    name: "studentenrabatt",
    path: "/studentenrabatt",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/studentenrabatt.vue")
  },
  {
    name: "vacancies",
    path: "/vacancies",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/vacancies/index.vue")
  },
  {
    name: "checkout-pending",
    path: "/checkout/pending",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/checkout/pending.vue")
  },
  {
    name: "signup-slug",
    path: "/signup/:slug(.*)*",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/signup/[...slug].vue")
  },
  {
    name: "vacancies-privacy",
    path: "/vacancies/privacy",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/vacancies/privacy.vue")
  },
  {
    name: "activation-token",
    path: "/activation/:token()",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/activation/[token].vue")
  },
  {
    name: "product-slug-id",
    path: "/product/:slug()/:id()",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/product/[slug]/[id].vue")
  },
  {
    name: "reset-password-token",
    path: "/reset-password/:token()",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/reset-password/[token].vue")
  },
  {
    name: "vacancies-city",
    path: "/vacancies/:city()",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/vacancies/[city]/index.vue")
  },
  {
    name: "service-subject",
    path: "/service/:subject()",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/[subject]/index.vue")
  },
  {
    name: "newsletter-language",
    path: "/newsletter-language",
    component: () => createClientPage(() => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/newsletter-language.client.vue"))
  },
  {
    name: "search-detail-searchTerm",
    path: "/search-detail/:searchTerm()",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/search-detail/[searchTerm].vue")
  },
  {
    name: "service-subject-answer",
    path: "/service/:subject()/:answer()",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/[subject]/[answer].vue")
  },
  {
    name: "vacancies-city-title-vacancy",
    path: "/vacancies/:city()/:title()/:vacancy()",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/vacancies/[city]/[title]/[vacancy].vue")
  },
  {
    name: "nl-about",
    path: "/nl/over-ons",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/about.vue")
  },
  {
    name: "de-about",
    path: "/de/uber-uns",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/about.vue")
  },
  {
    name: "en-about",
    path: "/en/about-us",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/about.vue")
  },
  {
    name: "nl-error",
    path: "/nl/error",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/error.vue")
  },
  {
    name: "de-error",
    path: "/de/error",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/error.vue")
  },
  {
    name: "en-error",
    path: "/en/error",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/error.vue")
  },
  {
    name: "nl-index",
    path: "/nl",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/index.vue")
  },
  {
    name: "de-index",
    path: "/de",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/index.vue")
  },
  {
    name: "en-index",
    path: "/en",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/index.vue")
  },
  {
    name: "nl-login",
    path: "/nl/inloggen",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/login.vue")
  },
  {
    name: "de-login",
    path: "/de/einloggen",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/login.vue")
  },
  {
    name: "en-login",
    path: "/en/login",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/login.vue")
  },
  {
    name: "nl-terms",
    path: "/nl/voorwaarden",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/terms.vue")
  },
  {
    name: "de-terms",
    path: "/de/agb",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/terms.vue")
  },
  {
    name: "en-terms",
    path: "/en/terms-and-conditions",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/terms.vue")
  },
  {
    name: accountomlKmDdKwpdTXP6M5VM4Qd2oEouKNPYmixrMc6JghywMeta?.name,
    path: "/nl/account",
    meta: {"middleware":"authenticated","forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account.vue"),
    children: [
  {
    name: "nl-account",
    path: "",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/index.vue")
  },
  {
    name: "nl-account-orders",
    path: "/nl/account/orders",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/orders.vue")
  },
  {
    name: "nl-account-recent",
    path: "/nl/account/recent",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/recent.vue")
  },
  {
    name: "nl-account-profile",
    path: "/nl/account/profile",
    meta: {"middleware":"authenticated"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/profile.vue")
  },
  {
    name: "nl-account-settings",
    path: "/nl/account/settings",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/settings.vue")
  },
  {
    name: "nl-account-wishlist",
    path: "/nl/account/wishlist",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/wishlist.vue")
  },
  {
    name: "nl-account-addresses",
    path: "/nl/account/addresses",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/addresses.vue")
  },
  {
    name: "nl-account-notifications",
    path: "/nl/account/notifications",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/notifications.vue")
  },
  {
    name: "nl-account-reset-password",
    path: "/nl/account/reset-password",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/reset-password.vue")
  },
  {
    name: "nl-account-notification-id",
    path: "/nl/account/notification/:id",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/notification/[id].vue")
  },
  {
    name: "nl-account-order-type-invoiceId",
    path: "/nl/account/order/:type()/:invoiceId()",
    meta: { ...(_91invoiceId_93GKbiHLvbQOE1AJoVXznUD4HxEqEcuNJwdTbfLcNkEZoMeta || {}), ...{"middleware":"authenticated"} },
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/order/[type]/[invoiceId].vue")
  }
]
  },
  {
    name: accountomlKmDdKwpdTXP6M5VM4Qd2oEouKNPYmixrMc6JghywMeta?.name,
    path: "/de/account",
    meta: {"middleware":"authenticated","forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account.vue"),
    children: [
  {
    name: "de-account",
    path: "",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/index.vue")
  },
  {
    name: "de-account-orders",
    path: "/de/account/orders",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/orders.vue")
  },
  {
    name: "de-account-recent",
    path: "/de/account/recent",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/recent.vue")
  },
  {
    name: "de-account-profile",
    path: "/de/account/meine-daten",
    meta: {"middleware":"authenticated"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/profile.vue")
  },
  {
    name: "de-account-settings",
    path: "/de/account/settings",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/settings.vue")
  },
  {
    name: "de-account-wishlist",
    path: "/de/account/wishlist",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/wishlist.vue")
  },
  {
    name: "de-account-addresses",
    path: "/de/account/addresses",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/addresses.vue")
  },
  {
    name: "de-account-notifications",
    path: "/de/account/notifications",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/notifications.vue")
  },
  {
    name: "de-account-reset-password",
    path: "/de/account/reset-password",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/reset-password.vue")
  },
  {
    name: "de-account-notification-id",
    path: "/de/account/notification/:id",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/notification/[id].vue")
  },
  {
    name: "de-account-order-type-invoiceId",
    path: "/de/account/order/:type()/:invoiceId()",
    meta: { ...(_91invoiceId_93GKbiHLvbQOE1AJoVXznUD4HxEqEcuNJwdTbfLcNkEZoMeta || {}), ...{"middleware":"authenticated"} },
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/order/[type]/[invoiceId].vue")
  }
]
  },
  {
    name: accountomlKmDdKwpdTXP6M5VM4Qd2oEouKNPYmixrMc6JghywMeta?.name,
    path: "/en/account",
    meta: {"middleware":"authenticated","forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account.vue"),
    children: [
  {
    name: "en-account",
    path: "",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/index.vue")
  },
  {
    name: "en-account-orders",
    path: "/en/account/orders",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/orders.vue")
  },
  {
    name: "en-account-recent",
    path: "/en/account/recent",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/recent.vue")
  },
  {
    name: "en-account-profile",
    path: "/en/account/profile",
    meta: {"middleware":"authenticated"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/profile.vue")
  },
  {
    name: "en-account-settings",
    path: "/en/account/settings",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/settings.vue")
  },
  {
    name: "en-account-wishlist",
    path: "/en/account/wishlist",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/wishlist.vue")
  },
  {
    name: "en-account-addresses",
    path: "/en/account/addresses",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/addresses.vue")
  },
  {
    name: "en-account-notifications",
    path: "/en/account/notifications",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/notifications.vue")
  },
  {
    name: "en-account-reset-password",
    path: "/en/account/reset-password",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/reset-password.vue")
  },
  {
    name: "en-account-notification-id",
    path: "/en/account/notification/:id",
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/notification/[id].vue")
  },
  {
    name: "en-account-order-type-invoiceId",
    path: "/en/account/order/:type()/:invoiceId()",
    meta: { ...(_91invoiceId_93GKbiHLvbQOE1AJoVXznUD4HxEqEcuNJwdTbfLcNkEZoMeta || {}), ...{"middleware":"authenticated"} },
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/account/order/[type]/[invoiceId].vue")
  }
]
  },
  {
    name: "nl-colofon",
    path: "/nl/colofon",
    meta: { ...(colofonf0SyTye_MA8Qwg_45lkyAmSAUkx3e3opCaF1HmQ_45GLaJEMeta || {}), ...{"forceLanguage":"nl"} },
    alias: ["/de/colofon"],
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/colofon.vue")
  },
  {
    name: "de-colofon",
    path: "/de/colofon",
    meta: { ...(colofonf0SyTye_MA8Qwg_45lkyAmSAUkx3e3opCaF1HmQ_45GLaJEMeta || {}), ...{"forceLanguage":"de"} },
    alias: ["/de/colofon"],
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/colofon.vue")
  },
  {
    name: "en-colofon",
    path: "/en/colofon",
    meta: { ...(colofonf0SyTye_MA8Qwg_45lkyAmSAUkx3e3opCaF1HmQ_45GLaJEMeta || {}), ...{"forceLanguage":"en"} },
    alias: ["/de/colofon"],
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/colofon.vue")
  },
  {
    name: "nl-contact",
    path: "/nl/contact",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/contact.vue")
  },
  {
    name: "de-contact",
    path: "/de/kontakt",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/contact.vue")
  },
  {
    name: "en-contact",
    path: "/en/contact",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/contact.vue")
  },
  {
    name: "nl-cookies",
    path: "/nl/cookies",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/cookies.vue")
  },
  {
    name: "de-cookies",
    path: "/de/cookies",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/cookies.vue")
  },
  {
    name: "en-cookies",
    path: "/en/cookies",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/cookies.vue")
  },
  {
    name: "nl-privacy",
    path: "/nl/privacy",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/privacy.vue")
  },
  {
    name: "de-privacy",
    path: "/de/datenschutzerklarung",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/privacy.vue")
  },
  {
    name: "en-privacy",
    path: "/en/privacy",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/privacy.vue")
  },
  {
    name: "nl-reviews",
    path: "/nl/reviews",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/reviews.vue")
  },
  {
    name: "de-reviews",
    path: "/de/erfahrungen",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/reviews.vue")
  },
  {
    name: "en-reviews",
    path: "/en/reviews",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/reviews.vue")
  },
  {
    name: "nl-register",
    path: "/nl/registreren",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/register.vue")
  },
  {
    name: "de-register",
    path: "/de/registrieren",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/register.vue")
  },
  {
    name: "en-register",
    path: "/en/register",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/register.vue")
  },
  {
    name: "nl-wishlist",
    path: "/nl/wishlist",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/wishlist.vue")
  },
  {
    name: "de-wishlist",
    path: "/de/wishlist",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/wishlist.vue")
  },
  {
    name: "en-wishlist",
    path: "/en/wishlist",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/wishlist.vue")
  },
  {
    name: "nl-slug",
    path: "/nl/:slug(.*)*",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/[...slug].vue")
  },
  {
    name: "de-slug",
    path: "/de/:slug(.*)*",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/[...slug].vue")
  },
  {
    name: "en-slug",
    path: "/en/:slug(.*)*",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/[...slug].vue")
  },
  {
    name: "nl-giftcards",
    path: "/nl/cadeaubonnen/:slug?/:id?",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/giftcards.vue")
  },
  {
    name: "de-giftcards",
    path: "/de/geschenkgutscheine/:slug?/:id?",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/giftcards.vue")
  },
  {
    name: "en-giftcards",
    path: "/en/giftcards/:slug?/:id?",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/giftcards.vue")
  },
  {
    name: "nl-storyblok",
    path: "/nl/storyblok",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/storyblok.vue")
  },
  {
    name: "de-storyblok",
    path: "/de/storyblok",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/storyblok.vue")
  },
  {
    name: "en-storyblok",
    path: "/en/storyblok",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/storyblok.vue")
  },
  {
    name: thank_45youBfAbgXxQZNHOZOGi4hBjkk4yUmYUlRv7cLjaWkBjilsMeta?.name,
    path: "/nl/thank-you",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/thank-you.vue"),
    children: [
  {
    name: "nl-thank-you",
    path: "/nl/thank-you/thank-you",
    component: () => createClientPage(() => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/thank-you.client.vue"))
  }
]
  },
  {
    name: thank_45youBfAbgXxQZNHOZOGi4hBjkk4yUmYUlRv7cLjaWkBjilsMeta?.name,
    path: "/de/thank-you",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/thank-you.vue"),
    children: [
  {
    name: "de-thank-you",
    path: "/de/thank-you/thank-you",
    component: () => createClientPage(() => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/thank-you.client.vue"))
  }
]
  },
  {
    name: thank_45youBfAbgXxQZNHOZOGi4hBjkk4yUmYUlRv7cLjaWkBjilsMeta?.name,
    path: "/en/thank-you",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/thank-you.vue"),
    children: [
  {
    name: "en-thank-you",
    path: "/en/thank-you/thank-you",
    component: () => createClientPage(() => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/thank-you.client.vue"))
  }
]
  },
  {
    name: "nl-foundation",
    path: "/nl/foundation",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/foundation.vue")
  },
  {
    name: "de-foundation",
    path: "/de/foundation",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/foundation.vue")
  },
  {
    name: "en-foundation",
    path: "/en/foundation",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/foundation.vue")
  },
  {
    name: "nl-newsletter",
    path: "/nl/nieuwsbrief",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/newsletter.vue")
  },
  {
    name: "de-newsletter",
    path: "/de/newsletter",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/newsletter.vue")
  },
  {
    name: "en-newsletter",
    path: "/en/newsletter",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/newsletter.vue")
  },
  {
    name: "nl-promotions",
    path: "/nl/promotions",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/promotions.vue")
  },
  {
    name: "de-promotions",
    path: "/de/promotions",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/promotions.vue")
  },
  {
    name: "en-promotions",
    path: "/en/promotions",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/promotions.vue")
  },
  {
    name: "nl-stores-map",
    path: "/nl/stores/map",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/stores/map.vue")
  },
  {
    name: "de-stores-map",
    path: "/de/stores/map",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/stores/map.vue")
  },
  {
    name: "en-stores-map",
    path: "/en/stores/map",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/stores/map.vue")
  },
  {
    name: "nl-styleguide",
    path: "/nl/styleguide",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/styleguide.vue")
  },
  {
    name: "de-styleguide",
    path: "/de/styleguide",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/styleguide.vue")
  },
  {
    name: "en-styleguide",
    path: "/en/styleguide",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/styleguide.vue")
  },
  {
    name: "nl-cart",
    path: "/nl/shopping-bag",
    meta: {"forceLanguage":"nl"},
    component: () => createClientPage(() => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/cart.client.vue"))
  },
  {
    name: "de-cart",
    path: "/de/shopping-bag",
    meta: {"forceLanguage":"de"},
    component: () => createClientPage(() => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/cart.client.vue"))
  },
  {
    name: "en-cart",
    path: "/en/shopping-bag",
    meta: {"forceLanguage":"en"},
    component: () => createClientPage(() => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/cart.client.vue"))
  },
  {
    name: "nl-guts-planet",
    path: "/nl/guts-planet",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/guts-planet.vue")
  },
  {
    name: "de-guts-planet",
    path: "/de/guts-planet",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/guts-planet.vue")
  },
  {
    name: "en-guts-planet",
    path: "/en/guts-planet",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/guts-planet.vue")
  },
  {
    name: "nl-stores",
    path: "/nl/stores",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/stores/index.vue")
  },
  {
    name: "de-stores",
    path: "/de/stores",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/stores/index.vue")
  },
  {
    name: "en-stores",
    path: "/en/stores",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/stores/index.vue")
  },
  {
    name: "nl-minipos",
    path: "/nl/minipos",
    meta: { ...(indexM1ql5_45U_45hRbULnFxMPaZN6_iUEbzJcKD5Vwsp1HdgAMMeta || {}), ...{"forceLanguage":"nl"} },
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/minipos/index.vue")
  },
  {
    name: "de-minipos",
    path: "/de/minipos",
    meta: { ...(indexM1ql5_45U_45hRbULnFxMPaZN6_iUEbzJcKD5Vwsp1HdgAMMeta || {}), ...{"forceLanguage":"de"} },
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/minipos/index.vue")
  },
  {
    name: "en-minipos",
    path: "/en/minipos",
    meta: { ...(indexM1ql5_45U_45hRbULnFxMPaZN6_iUEbzJcKD5Vwsp1HdgAMMeta || {}), ...{"forceLanguage":"en"} },
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/minipos/index.vue")
  },
  {
    name: "nl-service",
    path: "/nl/service",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/index.vue")
  },
  {
    name: "de-service",
    path: "/de/service",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/index.vue")
  },
  {
    name: "en-service",
    path: "/en/service",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/index.vue")
  },
  {
    name: "nl-warchild-info",
    path: "/nl/warchild/info",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/warchild/info.vue")
  },
  {
    name: "de-warchild-info",
    path: "/de/warchild/info",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/warchild/info.vue")
  },
  {
    name: "en-warchild-info",
    path: "/en/warchild/info",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/warchild/info.vue")
  },
  {
    name: "nl-win-slug",
    path: "/nl/win/:slug(.*)*",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/win/[...slug].vue")
  },
  {
    name: "de-win-slug",
    path: "/de/win/:slug(.*)*",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/win/[...slug].vue")
  },
  {
    name: "en-win-slug",
    path: "/en/win/:slug(.*)*",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/win/[...slug].vue")
  },
  {
    name: "nl-checkout-login",
    path: "/nl/checkout-login",
    meta: { ...(checkout_45loginHDAh8ELKMfliA7DWgiu54qrTLf76Vb56CGg3bm96TfcMeta || {}), ...{"forceLanguage":"nl"} },
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/checkout-login.vue")
  },
  {
    name: "de-checkout-login",
    path: "/de/checkout-login",
    meta: { ...(checkout_45loginHDAh8ELKMfliA7DWgiu54qrTLf76Vb56CGg3bm96TfcMeta || {}), ...{"forceLanguage":"de"} },
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/checkout-login.vue")
  },
  {
    name: "en-checkout-login",
    path: "/en/checkout-login",
    meta: { ...(checkout_45loginHDAh8ELKMfliA7DWgiu54qrTLf76Vb56CGg3bm96TfcMeta || {}), ...{"forceLanguage":"en"} },
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/checkout-login.vue")
  },
  {
    name: "nl-checkout",
    path: "/nl/checkout",
    meta: { ...(index4HN5Q9V2feOqL79jvJ9WMhtWaOrQDwZvT02QJruYpOwMeta || {}), ...{"forceLanguage":"nl"} },
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/checkout/index.vue")
  },
  {
    name: "de-checkout",
    path: "/de/checkout",
    meta: { ...(index4HN5Q9V2feOqL79jvJ9WMhtWaOrQDwZvT02QJruYpOwMeta || {}), ...{"forceLanguage":"de"} },
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/checkout/index.vue")
  },
  {
    name: "en-checkout",
    path: "/en/checkout",
    meta: { ...(index4HN5Q9V2feOqL79jvJ9WMhtWaOrQDwZvT02QJruYpOwMeta || {}), ...{"forceLanguage":"en"} },
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/checkout/index.vue")
  },
  {
    name: "nl-stores-store",
    path: "/nl/stores/:store()",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/stores/[store].vue")
  },
  {
    name: "de-stores-store",
    path: "/de/stores/:store()",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/stores/[store].vue")
  },
  {
    name: "en-stores-store",
    path: "/en/stores/:store()",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/stores/[store].vue")
  },
  {
    name: "nl-warchild",
    path: "/nl/warchild",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/warchild/index.vue")
  },
  {
    name: "de-warchild",
    path: "/de/warchild",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/warchild/index.vue")
  },
  {
    name: "en-warchild",
    path: "/en/warchild",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/warchild/index.vue")
  },
  {
    name: "nl-forgot-password",
    path: "/nl/wachtwoord-vergeten",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/forgot-password.vue")
  },
  {
    name: "de-forgot-password",
    path: "/de/passwort-vergessen",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/forgot-password.vue")
  },
  {
    name: "en-forgot-password",
    path: "/en/forgot-password",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/forgot-password.vue")
  },
  {
    name: "nl-recent-products",
    path: "/nl/recent-products",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/recent-products.vue")
  },
  {
    name: "de-recent-products",
    path: "/de/recent-products",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/recent-products.vue")
  },
  {
    name: "en-recent-products",
    path: "/en/recent-products",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/recent-products.vue")
  },
  {
    name: "nl-service-contact",
    path: "/nl/service/contact",
    meta: { ...(contacthnZXVdKuAOyrlPsgCEjqyGDcLHvX9q4MZQkh2_1j1u4Meta || {}), ...{"forceLanguage":"nl"} },
    alias: ["/contact"],
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/contact.vue")
  },
  {
    name: "de-service-contact",
    path: "/de/service/contact",
    meta: { ...(contacthnZXVdKuAOyrlPsgCEjqyGDcLHvX9q4MZQkh2_1j1u4Meta || {}), ...{"forceLanguage":"de"} },
    alias: ["/contact"],
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/contact.vue")
  },
  {
    name: "en-service-contact",
    path: "/en/service/contact",
    meta: { ...(contacthnZXVdKuAOyrlPsgCEjqyGDcLHvX9q4MZQkh2_1j1u4Meta || {}), ...{"forceLanguage":"en"} },
    alias: ["/contact"],
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/contact.vue")
  },
  {
    name: "nl-service-results",
    path: "/nl/service/results",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/results.vue")
  },
  {
    name: "de-service-results",
    path: "/de/service/results",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/results.vue")
  },
  {
    name: "en-service-results",
    path: "/en/service/results",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/results.vue")
  },
  {
    name: "nl-studentenrabatt",
    path: "/nl/studentenrabatt",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/studentenrabatt.vue")
  },
  {
    name: "de-studentenrabatt",
    path: "/de/studentenrabatt",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/studentenrabatt.vue")
  },
  {
    name: "en-studentenrabatt",
    path: "/en/studentenrabatt",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/studentenrabatt.vue")
  },
  {
    name: "nl-vacancies",
    path: "/nl/vacatures",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/vacancies/index.vue")
  },
  {
    name: "de-vacancies",
    path: "/de/stellenangebote",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/vacancies/index.vue")
  },
  {
    name: "en-vacancies",
    path: "/en/jobs",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/vacancies/index.vue")
  },
  {
    name: "nl-checkout-pending",
    path: "/nl/checkout/pending",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/checkout/pending.vue")
  },
  {
    name: "de-checkout-pending",
    path: "/de/checkout/pending",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/checkout/pending.vue")
  },
  {
    name: "en-checkout-pending",
    path: "/en/checkout/pending",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/checkout/pending.vue")
  },
  {
    name: "nl-signup-slug",
    path: "/nl/signup/:slug(.*)*",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/signup/[...slug].vue")
  },
  {
    name: "de-signup-slug",
    path: "/de/signup/:slug(.*)*",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/signup/[...slug].vue")
  },
  {
    name: "en-signup-slug",
    path: "/en/signup/:slug(.*)*",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/signup/[...slug].vue")
  },
  {
    name: "nl-vacancies-privacy",
    path: "/nl/vacatures/privacy",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/vacancies/privacy.vue")
  },
  {
    name: "de-vacancies-privacy",
    path: "/de/stellenangebote/privacy",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/vacancies/privacy.vue")
  },
  {
    name: "en-vacancies-privacy",
    path: "/en/jobs/privacy",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/vacancies/privacy.vue")
  },
  {
    name: "nl-activation-token",
    path: "/nl/activation/:token()",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/activation/[token].vue")
  },
  {
    name: "de-activation-token",
    path: "/de/activation/:token()",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/activation/[token].vue")
  },
  {
    name: "en-activation-token",
    path: "/en/activation/:token()",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/activation/[token].vue")
  },
  {
    name: "nl-product-slug-id",
    path: "/nl/product/:slug/:id",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/product/[slug]/[id].vue")
  },
  {
    name: "de-product-slug-id",
    path: "/de/artikel/:slug/:id",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/product/[slug]/[id].vue")
  },
  {
    name: "en-product-slug-id",
    path: "/en/product/:slug/:id",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/product/[slug]/[id].vue")
  },
  {
    name: "nl-reset-password-token",
    path: "/nl/reset-password/:token()",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/reset-password/[token].vue")
  },
  {
    name: "de-reset-password-token",
    path: "/de/reset-password/:token()",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/reset-password/[token].vue")
  },
  {
    name: "en-reset-password-token",
    path: "/en/reset-password/:token()",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/reset-password/[token].vue")
  },
  {
    name: "nl-vacancies-city",
    path: "/nl/vacatures/:city",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/vacancies/[city]/index.vue")
  },
  {
    name: "de-vacancies-city",
    path: "/de/stellenangebote/:city",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/vacancies/[city]/index.vue")
  },
  {
    name: "en-vacancies-city",
    path: "/en/jobs/:city",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/vacancies/[city]/index.vue")
  },
  {
    name: "nl-service-subject",
    path: "/nl/service/:subject()",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/[subject]/index.vue")
  },
  {
    name: "de-service-subject",
    path: "/de/service/:subject()",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/[subject]/index.vue")
  },
  {
    name: "en-service-subject",
    path: "/en/service/:subject()",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/[subject]/index.vue")
  },
  {
    name: "nl-newsletter-language",
    path: "/nl/newsletter-language",
    meta: {"forceLanguage":"nl"},
    component: () => createClientPage(() => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/newsletter-language.client.vue"))
  },
  {
    name: "de-newsletter-language",
    path: "/de/newsletter-language",
    meta: {"forceLanguage":"de"},
    component: () => createClientPage(() => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/newsletter-language.client.vue"))
  },
  {
    name: "en-newsletter-language",
    path: "/en/newsletter-language",
    meta: {"forceLanguage":"en"},
    component: () => createClientPage(() => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/newsletter-language.client.vue"))
  },
  {
    name: "nl-search-detail-searchTerm",
    path: "/nl/zoeken/:searchTerm?",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/search-detail/[searchTerm].vue")
  },
  {
    name: "de-search-detail-searchTerm",
    path: "/de/suche/:searchTerm?",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/search-detail/[searchTerm].vue")
  },
  {
    name: "en-search-detail-searchTerm",
    path: "/en/search/:searchTerm?",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/search-detail/[searchTerm].vue")
  },
  {
    name: "nl-service-subject-answer",
    path: "/nl/service/:subject()/:answer()",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/[subject]/[answer].vue")
  },
  {
    name: "de-service-subject-answer",
    path: "/de/service/:subject()/:answer()",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/[subject]/[answer].vue")
  },
  {
    name: "en-service-subject-answer",
    path: "/en/service/:subject()/:answer()",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/service/[subject]/[answer].vue")
  },
  {
    name: "nl-vacancies-city-title-vacancy",
    path: "/nl/vacatures/:city?/:title/:vacancy",
    meta: {"forceLanguage":"nl"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/vacancies/[city]/[title]/[vacancy].vue")
  },
  {
    name: "de-vacancies-city-title-vacancy",
    path: "/de/stellenangebote/:city?/:title/:vacancy",
    meta: {"forceLanguage":"de"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/vacancies/[city]/[title]/[vacancy].vue")
  },
  {
    name: "en-vacancies-city-title-vacancy",
    path: "/en/jobs/:city?/:title/:vacancy",
    meta: {"forceLanguage":"en"},
    component: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/pages/vacancies/[city]/[title]/[vacancy].vue")
  }
]